import React from 'react';
import Constants from '../../../Constants';

const DashboardContext = React.createContext({
    project: 'sportparkzuid',
    rooms: Constants.rooms
});

export default DashboardContext;